import { createAction, handleActions } from 'redux-actions'
import API from 'services'

// 타입 정의
export const LOGIN = 'auth/LOGIN';
export const TOGGLE_SIGN_IN_MODAL = 'auth/TOGGLE_SIGN_IN_MODAL';
export const TOGGLE_SIGN_UP_MODAL = 'auth/TOGGLE_SIGN_UP_MODAL';
export const LOGOUT = 'auth/LOGOUT';
export const UPDATE_USER_INFO = 'auth/UPDATE_USER_INFO';

// 액션 내보내기
export const toggleSignInModal = createAction(
    TOGGLE_SIGN_IN_MODAL,
    () =>{
        return null
    }
)
export const toggleSignUpModal = createAction(
    TOGGLE_SIGN_UP_MODAL,
    () =>{
        return null
    }
)
export const login = createAction(
    LOGIN,
    (token, memberinfo) =>{
        window.localStorage.setItem('token', token);
        API.tokenUpdate(token)
        return {
            token,
            memberinfo
        }
    }
)
export const logout = createAction(
    LOGOUT,
    (type)=>{
        if(type === "all"){
            API.accounts().logoutAll()
        }else{
            API.accounts().logout()
        }
        API.tokenUpdate(null)
        localStorage.removeItem("token")
    }
)
export const updateUserInfo = createAction(
    UPDATE_USER_INFO,
    (updatedInfo) =>{
        return {
            updatedInfo
        }
    }
)

// 초기 상태값
const initialState = {
    isFetching: false,
    isAuthenticated: !!localStorage.getItem('token'),
    token: localStorage.getItem('token') ? localStorage.getItem('token') : null,
    isOpenSignInModal:false,
    isOpenSignUpModal:false,
    memberinfo:{
        name:'',
        email:'',
        level:''
    }
}

// 리듀서 내보내기
export default handleActions({
    [LOGIN]:(state, {payload:{token, memberinfo}}) => {
        return {
            ...state,
            isFetching: false,
            isAuthenticated: true,
            token: token,
            memberinfo
        }
    },
    [LOGOUT]:(state) => {
        return {
            ...state,
            isFetching: false,
            isAuthenticated: false,
            token: null,
            memberinfo:{
                name:'',
                email:'',
                level:'',
                mb_bankAccount:''
            }
        }
    },
    [TOGGLE_SIGN_IN_MODAL]:(state) => {
        return {
            ...state,
            isOpenSignInModal:!state.isOpenSignInModal
        }
    },
    [TOGGLE_SIGN_UP_MODAL]:(state) => {
        return {
            ...state,
            isOpenSignUpModal:!state.isOpenSignUpModal
        }
    },
    [UPDATE_USER_INFO]:(state, {payload:{ updatedInfo }}) => {
        return {
            ...state,
            memberinfo:{
                ...state.memberinfo,
                ...updatedInfo
            }
        }
    },
}, initialState);
